import React from 'react';
import * as PropTypes from 'prop-types';
import { Box, makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { colors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';

const useStyles = makeStyles((theme: ITheme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    maxWidth: '100%',
    padding: '24px',
    marginBottom: 0,
  },
  title: {
    marginBottom: theme.spacing(1),
    fontSize: 24,
    fontFamily: 'DM Serif Display',
  },
  titleContainer: {
    borderBottom: `1px solid`,
    borderBottomColor: colors.lightGray,
  },
}));

const PanelSection = ({
  title,
  children,
}: {
  title: string;
  children: any;
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Box className={classes.titleContainer}>
        <Typography className={classes.title}>{title}</Typography>
      </Box>
      {children}
    </div>
  );
};

PanelSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};

PanelSection.defaultProps = {
  children: null,
};

export default PanelSection;
